import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-csw-text',
  templateUrl: './csw-text.component.html',
  styleUrls: ['./csw-text.component.scss'],
  imports: [NgStyle]
})
export class CswTextComponent {
  @Input() text: any;
  @Input() styleConfig: {
    color?: string;
    fontSize?: string;
    fontWeight?: string;
  } = {};
  @Input() customClass: string;

  // Accessibility inputs
  @Input() role: string;
  @Input() ariaLabel: string;
  @Input() ariaLive: 'off' | 'polite' | 'assertive' = 'off';
  @Input() ariaHidden: boolean = false;
  @Input() ariaDescribedby: string;
  @Input() ariaLabelledby: string;
}
